import React from 'react';
import TranslateIcon from '@material-ui/icons/Translate';
import { IconButton, Button } from '@material-ui/core';
import { ApolloError, useMutation } from '@apollo/client';
import { Toast } from 'components/Toast';
import { getFriendlyErrorMessage } from 'utils/errorHelper';
import Swal from 'sweetalert2';
import { TRANSLATE_CATEGORIES_DESCRIPTION } from 'queries/category';
import useStyles from 'components/FormContents/components/ActionButtons/styles';

interface ITranslateCategoryDescription {
  siteDomain: string;
}

export const TranslateCategoryDescription: React.FC<ITranslateCategoryDescription> = ({
  siteDomain,
}) => {
  const classes = useStyles();

  const handleOnCompletedMutation = () => {
    Toast('Action executed with success!');
  };

  const handleOnErrorMutation = (error: ApolloError) => {
    Toast(getFriendlyErrorMessage(error), 'error');
  };

  const [translateCategories] = useMutation(TRANSLATE_CATEGORIES_DESCRIPTION, {
    onCompleted: handleOnCompletedMutation,
    onError: handleOnErrorMutation,
    variables: {
      siteDomain,
    },
  });

  const confirmAlert = async (subtitle: string) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      html: subtitle,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#78001b',
      reverseButtons: true,
      confirmButtonText: 'Confirm',
      customClass: {
        container: classes.swalDialog,
      },
    });
    return result.value;
  };

  const createTranslation = async () => {
    if (
      await confirmAlert(
        `Do you want to translate this categories description?
        <br>
        <span style="font-size: 14px; padding-top: 14px; display: inline-block; color: red;">
          Note: The categories will be translated into the languages that are in the site settings.
        </span>`,
      )
    ) {
      translateCategories();
    }
  };

  return (
    <IconButton onClick={() => createTranslation()}>
      <Button
        variant="outlined"
        color="primary"
        // disabled={disabled}
        fullWidth
      >
        <TranslateIcon />
        &nbsp; Description
      </Button>
    </IconButton>
  );
};
